import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function invalidPhoneNumberValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const digits = (control.value || '').replace(/\D/g, '');
    const isValid = digits.length === 10;
    return !isValid ? { invalidPhoneNumber: { value: control.value } } : null;
  };
}
